import { Typography, Chip, Stack } from 'components/base';
import { normalText } from 'assets/colors/colors';
import { RenderChipsProps, RenderTagsProps } from '../../types/types';
import { valueStyles } from '../../styles/styles';

export function RenderTags<T>({
  value,
  getOptionLabel,
  customSelectedLabel,
  showCount = true,
}: RenderTagsProps<T>) {
  return customSelectedLabel ? (
    <Typography variant="body2" color={normalText.dark} noWrap>
      {`${value?.length} ${customSelectedLabel} selected`}
    </Typography>
  ) : (
    <>
      <Typography variant="body2" sx={valueStyles}>
        {value
          ?.slice(0, 1)
          ?.map((option) => getOptionLabel(option))
          ?.join(' ')}{' '}
      </Typography>
      {value?.length > 1 && showCount && (
        <Typography variant="subtitle2" ml={1.5}>
          +{value?.length - 1}
        </Typography>
      )}
    </>
  );
}

export function RenderChips<T>({
  value = [],
  getOptionLabel,
  getTagProps,
  onDeleteChip,
  limitTags = 1,
  fullWidthChips = false,
  style,
}: RenderChipsProps<T>) {
  const hasLimit = limitTags !== -1;
  const displayedChips = hasLimit ? value.slice(0, limitTags) : value;
  const showExtraCount = hasLimit ? value.length - limitTags : 0;

  return (
    <Stack direction="row" flexWrap="wrap" alignItems="center" sx={style}>
      {displayedChips?.map((option, index) => {
        const tagProps = getTagProps({ index });
        return (
          <Chip
            {...tagProps}
            key={`${index}-${getOptionLabel(option)}-chip`}
            label={getOptionLabel(option)}
            onDelete={(event) => {
              tagProps?.onDelete?.(event);
              if (onDeleteChip) {
                onDeleteChip();
              }
            }}
            variant="outlined"
            sx={{
              maxWidth: fullWidthChips ? '100%' : '250px',
              overflow: 'hidden !important',
            }}
          />
        );
      })}
      {showExtraCount > 0 && (
        <Typography variant="subtitle2" ml={1.5}>
          +{showExtraCount}
        </Typography>
      )}
    </Stack>
  );
}
